import { initContract } from "@ts-rest/core";
import { createQuickbooksConnectionBodySchema } from "@common/schemas/quickbooks-connection.schema";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { IntegrationConnectionDto } from "../dto/integrationConnection/integration-connection.dto";

const c = initContract();

export const quickbooksContract = c.router(
    {
        createConnection: {
            method: "POST",
            path: "/",
            body: createQuickbooksConnectionBodySchema,
            responses: {
                201: c.type<IntegrationConnectionDto>(),
                400: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/quickbooks",
    },
);
